import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment';
import Swal from 'sweetalert2'
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { flatten } from '@angular/compiler';
import { GetTitleService } from 'src/app/services/contacts/getTitle/get-title.service';
import { async } from '@angular/core/testing';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GetCountryStateCityService } from 'src/app/services/contacts/getCountryStateCity/get-country-state-city.service';
import { PinCodeToGetDetailsService } from 'src/app/services/contacts/pinCodeToGetDetails/pin-code-to-get-details.service';
import { CreateNewpartnerIdService } from 'src/app/services/contacts/createNewpartnerId/create-newpartner-id.service';
import { GetAllLanguageService } from 'src/app/services/contacts/getAllLanguage/get-all-language.service';
import { GetAllEducationService } from 'src/app/services/contacts/getAllEducation/get-all-education.service';
import { GetPartnerIDService } from 'src/app/services/donation/getPartnerID/get-partner-id.service';
import { LoginService } from 'src/app/services/auth/login/login.service';

declare var $: any
declare var app: any


@Component({
  selector: 'app-edit-create-new-partner-idin-event',
  templateUrl: './edit-create-new-partner-idin-event.component.html',
  styleUrls: ['./edit-create-new-partner-idin-event.component.less']
})
export class EditCreateNewPartnerIdinEventComponent implements OnInit {

  public isActive = new Subject()

  @Output() createResponse = new EventEmitter<any>()
  data
  @Input()
  set details(data) {
    if (data) {
      this.data = data;
      console.log(this.data)
      this.noCityAvailable = true
      this.partnerUpdateForm.patchValue({
        partner_id: this.data.partner_id,
        title_name: this.data.title_name,
        full_name: this.data.full_name,
        country_name: this.data.country_name,
        mobileNumber: this.data.primary_mobile_no,
        email_id: this.data.email_id,

        address_line1: this.data.address_line1,
        address_line2: this.data.address_line2,
        address_line3: this.data.address_line3,
        pincode: this.data.pincode,
        city: this.data.city,
        district: this.data.district,

        sex: this.data.sex,
        martial_status: this.data.martial_status,
        dob: this.data.dob,
        profession: this.data.professional_id,


        is_born_again: this.data.is_born_again,
        ministry_name: this.data.ministry_name,
        select_ministry: this.data.ministry_id,
        ministry_type: this.data.is_full_time,
        aadhar_number: this.data.id_proof,
        denomination: this.data.denomination,
        church_name: this.data.church_name,
        pastor_name: this.data.pastor_name,

      })
      this.getTitle(this.data.title_id)
      this.getAllCSC(this.data.country_name, this.data.state_name)
      this.ifForeign = this.data.country_name != 'India' ? true : false
      this.pinCodeToGetDetails(this.data.pincode)

      this.getLanguage(this.data.languages_known_ids === null ? '' : this.data.languages_known_ids.split(','))
      this.getEduction(this.data.education_id)

      setTimeout(function () {
        $(`.profession`).selectpicker('refresh');
        $(`.selectMinistry`).selectpicker('refresh');
        $(`#denomination`).selectpicker('refresh');
      }, 100)

      // this.getChurch(this.data.church_name)
    }
  }

  submitLoading: boolean = false
  isSubmitted: boolean = false
  partnerUpdateForm: FormGroup;

  /** 
   * create partner ID variables
   */
  public allTitle: any
  public allCSC: any
  public tempState: any
  public allState: any
  public allCity: any
  public allDistrict: any
  public countryID: any
  public stateID: any
  public cityID: any
  public province: Boolean = false
  public marital = {
    married: false
  }
  public denominationData: any = [
    "Roman Catholic",
    "Marthoma Church",
    "Jacobite Church",
    "CSI",
    "CNI",
    "Evangelical Church",
    "Lutheran Church",
    "Methodist Church",
    "Baptist Church",
    "Brethren Church",
    "Pentecostal Church",
    "Faith Berachah",
    "Others",
  ]

  /**
  * language and education
  */
  public allLanguage: any = []
  public allEduction: any = []

  /**
 * no value in selection box
 */
  public noCountryAvailable: Boolean = true
  public noStateAvailable: Boolean = true
  public noCityAvailable: Boolean = true
  public noCityAvailableCancelButton: Boolean = true
  public noDistrictAvailable: Boolean = true

  constructor(
    private formBuilder: FormBuilder,
    private GetTitleService: GetTitleService,
    private GetCountryStateCityService: GetCountryStateCityService,
    private PinCodeToGetDetailsService: PinCodeToGetDetailsService,
    private CreateNewpartnerIdService: CreateNewpartnerIdService,
    private GetAllLanguageService: GetAllLanguageService,
    private GetAllEducationService: GetAllEducationService,
    private GetPartnerIDService: GetPartnerIDService,
    private LoginService: LoginService,
  ) {

  }


  async ngOnInit() {

    this.partnerUpdateForm = this.formBuilder.group({
      partner_id: ['', Validators.required],
      title_name: ['', Validators.required],
      full_name: ['', Validators.required],
      country_name: ['', Validators.required],
      mobileNumber: ['', Validators.required],
      email_id: [''],

      address_line1: ['', Validators.required],
      address_line2: [''],
      address_line3: [''],
      pincode: ['', Validators.required],
      state_name: ['', Validators.required],
      city: ['', Validators.required],
      district: [''],


      sex: ['', Validators.required],
      martial_status: ['', Validators.required],
      languages_known: [''],
      education_name: [''],
      dob: [''],
      profession: [''],

      is_born_again: [''],
      ministry_name: [''],
      select_ministry: [''],
      ministry_type: [''],
      aadhar_number: [''],
      denomination: [''],
      church_name: [''],
      pastor_name: [''],

    });


  }

  getAllCSC(value, stateValue) {
    this.GetCountryStateCityService.getAllCountrySub().subscribe((result: any) => {
      if (result.statusText == "Unknown Error" || result.statusCode == 500) {
        // this.ServerStatusService.notify(`SERVER-DOWN-CRITICAL check the logs and fix the issue [ Event Register API Error ] [ Get Title => API Error ]`)
        // app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
      }
      this.allCSC = result.data
      console.log(this.allCSC)
      if (this.data.country_name) {
        this.getAllState(this.data.country_name, stateValue)
      }
      this.partnerUpdateForm.patchValue({
        country_name: value,
      })
      setTimeout(function () {
        $(`.country`).selectpicker('refresh');
      }, 100)
    })
  }

  checkState: boolean = false
  getAllState(countryValue, value) {

    let temp = this.allCSC.filter(country => country.name == countryValue)
    console.log(temp)
    this.countryID = temp[0].id

    this.GetCountryStateCityService.getAllStateSub(temp[0].id).subscribe((result: any) => {
      if (result.statusText == "Unknown Error" || result.statusCode == 500) {
        // this.ServerStatusService.notify(`SERVER-DOWN-CRITICAL check the logs and fix the issue [ Event Register API Error ] [ Get Title => API Error ]`)
        // app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
      }
      this.tempState = result.data
      this.allState = result.data
      let checkState = this.allState.filter(val => { return val.name == value })
      if (checkState.length === 0) {
        this.checkState = true
      }
      console.log(value)
      setTimeout(function () {
        $(`.state`).selectpicker('refresh');
        $("[data-id='State']").prop('disabled', false);
      }, 100)
    })
    this.partnerUpdateForm.patchValue({
      state_name: value,
    })
  }

  getAllStateValue(countryValue) {
    console.log(countryValue)
    this.ifForeign = countryValue != 'India' ? true : false
    let temp = this.allCSC.filter(country => country.name == countryValue)
    console.log(temp)
    this.countryID = temp[0].id
    this.GetCountryStateCityService.getAllStateSub(temp[0].id).subscribe((result: any) => {
      if (result.statusText == "Unknown Error" || result.statusCode == 500) {
        // this.ServerStatusService.notify(`SERVER-DOWN-CRITICAL check the logs and fix the issue [ Event Register API Error ] [ Get Title => API Error ]`)
        // app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
      }
      this.tempState = result.data
      this.allState = result.data
      setTimeout(function () {
        $(`.state`).selectpicker('refresh');
        $("[data-id='State']").prop('disabled', false);
      }, 100)
    })
  }


  // This function we are not using
  getAllCity(stateValue, value) {
    let temp = this.tempState.filter(ele => ele.name == stateValue)
    this.stateID = temp[0].id
    this.GetCountryStateCityService.getAllCitySub(this.countryID, temp[0].id).subscribe((result: any) => {
      if (result.statusText == "Unknown Error" || result.statusCode == 500) {
        // app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
      }
      this.allCity = result.data
      this.partnerUpdateForm.patchValue({
        city: value,
      })
      // setTimeout(function () {
      //   $(`.city`).selectpicker('refresh');
      //   $("[data-id='City']").prop('disabled', false);
      // }, 100)
    })
  }

  // This function we are not using
  getAllCityValue(stateValue) {
    let temp = this.tempState.filter(ele => ele.name == stateValue)
    this.stateID = temp[0].id
    this.checkState = false
    this.GetCountryStateCityService.getAllCitySub(this.countryID, temp[0].id).subscribe((result: any) => {
      if (result.statusText == "Unknown Error" || result.statusCode == 500) {
        // app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
      }
      this.noCityAvailable = false
      this.allCity = result.data
      // this.partnerUpdateForm.patchValue({
      //   city: value,
      // })
      setTimeout(function () {
        $(`.city`).selectpicker('refresh');
        $("[data-id='City']").prop('disabled', false);
        $("[data-id='District']").prop('disabled', false);
      }, 100)
    })
  }

  invalidPin
  pinCodeLoader
  pinCodeToGetDetails(value) {
    if (!this.ifForeign) {
      let checkValue = /\d{6}/
      this.invalidPin = false
      if (checkValue.test(value)) {
        this.pinCodeLoader = true
        let result = this.PinCodeToGetDetailsService.getPinDetailsSub(value).subscribe((result: any) => {
          if (result.status == 404) {
            this.pinCodeLoader = false
            this.invalidPin = true
          } else {
            this.pinCodeLoader = false
            let selectedPin = result.data
            // this.pintoPopulate.state = selectedPin[0].STATE_NAME
            // this.pintoPopulate.state_id = selectedPin[0].STATE_ID
            // this.pintoPopulate.district = selectedPin[0].DISTRICT_NAME

            // this.getSelectedState(this.pintoPopulate.state)
            //           $("#address3").val(function() {
            //     return this.value + ','POST_OFFICE;
            // });
            // if (selectedPin.length != 1) {
            // this.allState = []
            this.allDistrict = []
            // this.allCity = []
            selectedPin.forEach(element => {
              // this.allState.push({name:element.STATE_NAME})
              this.allDistrict.push(element.DISTRICT_NAME)
            });
            // this.allState.push({name:"Others"})
            // this.allDistrict.push("Others")

            setTimeout(function () {
              $(`.district`).selectpicker('refresh');
              $("[data-id='District']").prop('disabled', false);
            }, 100)
          }
        })
        // }
      }
    }

  }

  getSelectedCity(val) {
    if (val == "Others") {
      this.noCityAvailable = false
    }
    let temp = this.allCity.filter(ele => ele.name == val)
    this.cityID = temp[0].id
  }

  getLanguage(value) {

    this.GetAllLanguageService.getAllLanguageSub().subscribe((result: any) => {
      if (result.statusText == "Unknown Error" || result.statusCode == 500) {
        // this.ServerStatusService.notify(`SERVER-DOWN-CRITICAL check the logs and fix the issue [ Event Register API Error ] [ Get Title => API Error ]`)
        // app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
      }
      this.allLanguage = result.data
      this.partnerUpdateForm.patchValue({
        languages_known: value,
      })
      setTimeout(function () {
        $(`.language`).selectpicker('refresh');
      }, 100)
    })
  }

  getEduction(value) {
    this.GetAllEducationService.getAllEducationSub().subscribe((result: any) => {
      if (result.statusText == "Unknown Error" || result.statusCode == 500) {
        // this.ServerStatusService.notify(`SERVER-DOWN-CRITICAL check the logs and fix the issue [ Event Register API Error ] [ Get Title => API Error ]`)
        // app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
      }
      this.allEduction = result.data
      this.partnerUpdateForm.patchValue({
        education_name: value,
      })
      setTimeout(function () {
        $(`.eduction`).selectpicker('refresh');
      }, 100)
    })
  }

  getChurch(value) {
    this.allEduction = this.denominationData
    this.partnerUpdateForm.patchValue({
      church_name: value,
    })
    setTimeout(function () {
      $(`.denomination`).selectpicker('refresh');
    }, 100)
  }

  get partnerUpdateFormData() {
    return this.partnerUpdateForm.controls;
  }

  updatePartnerDetails() {
    let user_id = JSON.parse(localStorage.getItem("userDetails"))
    if (user_id == undefined || user_id == null) this.LoginService.userLogOut()
    this.isSubmitted = true

    if (this.checkState) {
      return
    }
    Object.keys(this.partnerUpdateForm.controls).forEach(key => {
      const controlErrors = this.partnerUpdateForm.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
    if (this.partnerUpdateForm.valid) {
      this.submitLoading = true
      console.log(this.partnerUpdateForm.value)
      let data = this.partnerUpdateForm.value
      this.CreateNewpartnerIdService.updatePartnerDetails(data).subscribe((result: any) => {
        if (result.status) {
          this.submitLoading = false
          Swal.fire(
            'Success!',
            'Partner Details updated successfully..!',
            'success'
          ).then(async (result) => {
            $("#editPartnerID").modal("hide");
            this.createResponse.emit({ partnerID: data.partner_id, status: "Done" })
          })
        }

      }, err => {
        this.submitLoading = false
        Swal.fire(
          'Failed!',
          'Partner Details update failed..!',
          'error'
        )
      })
    }
  }

  getTitle(value) {
    this.GetTitleService.getAllTitleSub().subscribe((result: any) => {
      if (result.statusText == "Unknown Error" || result.statusCode == 500) {
        // this.ServerStatusService.notify(`SERVER-DOWN-CRITICAL check the logs and fix the issue [ Event Register API Error ] [ Get Title => API Error ]`)
        // app.notifier.showError("Please try after some time. Since some maintenance is going on..!");
      }
      this.allTitle = result.data
      this.partnerUpdateForm.patchValue({
        title_name: value,
      })
      setTimeout(function () {
        $(`.title`).selectpicker('refresh');
      }, 100)
    })

  }


  public firstName: Boolean = false
  public LastName: Boolean = false
  public Occupation: Boolean = false
  public ChurchName: Boolean = false
  public PastorAddress: Boolean = false
  public PastorName: Boolean = false
  public Denomination: Boolean = false
  public PresentMinistry: Boolean = false
  public AadharNumber: Boolean = false
  public MinistryName: Boolean = false
  async checkSplChar(key, value) {

    switch (key) {
      case 1:
        var regex = /^[A-Za-z0-9 ]+$/
        if (value.length == 0) {
          return
        }
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.firstName = true
        } else {
          this.firstName = false
        }

        break;
      case 2:
        var regex = /^[A-Za-z0-9 ]+$/
        var isValid = regex.test(value);
        if (value.length == 0) {
          return
        }
        if (!isValid && value !== '') {
          this.LastName = true
        } else {
          this.LastName = false
        }

        break;
      case 3:
        var regex = /^[A-Za-z0-9 ]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.Occupation = true
        } else {
          this.Occupation = false
        }

        break;
      case 4:
        var regex = /^[A-Za-z0-9 ]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.ChurchName = true
        } else {
          this.ChurchName = false
        }

        break;
      case 5:
        var regex = /^[A-Za-z0-9 \r\n]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.PastorAddress = true
        } else {
          this.PastorAddress = false
        }

        break;
      case 6:
        var regex = /^[A-Za-z0-9 ]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.PresentMinistry = true
        } else {
          this.PresentMinistry = false
        }
      case 7:
        var regex = /^[A-Za-z0-9 \r\n]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.PastorName = true
        } else {
          this.PastorName = false
        }
        break;
      case 8:
        var regex = /^[A-Za-z0-9 \r\n]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.Denomination = true
        } else {
          this.Denomination = false
        }
        break;
      case 9:
        var regex = /^[A-Za-z0-9 \r\n]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.MinistryName = true
        } else {
          this.MinistryName = false
        }
        break;
      case 10:
        var regex = /^[A-Za-z0-9 \r\n]+$/
        var isValid = regex.test(value);
        if (!isValid && value !== '') {
          this.AadharNumber = true
        } else {
          this.AadharNumber = false
        }
        break;
    }
  }

  backToSelect(val) {
    switch (val) {
      case 1:
        this.noCountryAvailable = true

        this.pinMsg = true
        this.noStateAvailable = true
        this.noCityAvailable = true
        this.ifForeign = true
        this.province = false
        setTimeout(function () {
          $(`.country`).selectpicker('refresh');
          $(`.state`).selectpicker('refresh');
          $(`.city`).selectpicker('refresh');
          $(`.district`).selectpicker('refresh');
          // $("[data-id='State']").prop('disabled', true);
          // $("[data-id='City']").prop('disabled', true);
          // $("[data-id='District']").prop('disabled', true);
        }, 100)
        break;
      case 2:
        this.noStateAvailable = true
        setTimeout(function () {
          $(`.state`).selectpicker('refresh');
        }, 100)
        break;
      case 3:
        this.noCityAvailable = true
        setTimeout(function () {
          $(`.city`).selectpicker('refresh');
        }, 100)
      case 4:
        this.noDistrictAvailable = true
        setTimeout(function () {
          $(`.district`).selectpicker('refresh');
        }, 100)
        break;
    }
  }

  public pinMsg: Boolean = true
  public ifForeign: Boolean = false
  public maxNumber: any = 10
  getSelectedCountry(event) {
    // if (this.step1.value['country'] == "Others") {
    //   this.step1.controls['countryOther'].setValidators([Validators.required])
    //   this.pinMsg = false
    //   this.noStateAvailable = true
    //   this.noCityAvailable = true
    //   this.ifForeign = false
    // } else {
    //   this.pinMsg = false
    //   this.noStateAvailable = false
    //   this.noCityAvailable = false
    //   this.ifForeign = false

    //   let ID = this.partnerUpdateForm.value['country'];
    //   let temp = this.worlddata.filter((country) => country.name == ID);
    //   let countryID = temp[0].id;
    //   this.countryID = temp[0].id
    //   this.apiService
    //     .get(`${ApiList.WORLDDATA}?country_id=${countryID}`)
    //     .subscribe((response) => {
    //       this.statedata = response['data'];
    //       this.statedata.push({ name: 'Others' });
    //     });
    //   if (ID == 'India') {
    //     this.partnerUpdateForm.controls['district'].setValidators([Validators.required]);
    //     this.maxNumber = 10
    //   } else {
    //     this.partnerUpdateForm.controls['district'].setValidators([
    //       Validators.maxLength(200),
    //     ]);
    //     this.ifForeign = true
    //     this.maxNumber = 20
    //   }
    //   this.partnerUpdateForm.controls['district'].updateValueAndValidity();
    // }
  }


  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  keyPressEvent(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode != 8 && !pattern.test(inputChar))) {
      if (event.keyCode != 13) {
        event.preventDefault();
      }
    }
  }
}
